// extracted by mini-css-extract-plugin
export var wordContainer = "_pj-0";